import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ApiService } from '../services/api.service';
import { UtilitiesService } from '../services/utilities.service';
import Swal from 'sweetalert2'

@Component({
    selector: 'app-packages',
    templateUrl: './packages.component.html',
    styleUrls: ['./packages.component.css'],
    standalone: false
})
export class PackagesComponent implements OnInit {
  page = 1;
  pageSize = 10;

  list_length = 0;
  items: any[] = [];
  services: any[] = [];
  token: any;

  item = {
    name: null,
    service: null,
    full_price: null,
    session_price: null,
    no_sessions: null
  }
  new_item = {
    name: null,
    service: null,
    full_price: null,
    session_price: null,
    no_sessions: null
  }

  update_key: any;
  Swal = 'sweetalert2'

  constructor(public utility: UtilitiesService, private api: ApiService, private modalService: NgbModal, private titleService: Title) {
    this.utility.show = true;
    this.token = localStorage.getItem('access_token');
  }

  ngOnInit(): void {
    this.titleService.setTitle('Packages Settings');
    this.getPackages();
  }

  open(content: any) {
    this.modalService.open(content);
  }

  edit(content: any, item: any) {
    this.update_key = item.id;
    this.new_item = item;

    this.new_item.service = item.service_id;
    
    this.modalService.open(content);
  }

  async getPackages() {
    const sub = this.api.get('packages/', this.token).subscribe(
      async data => {
        let objects: any = {}
        objects = data;

        this.items = objects;
        this.list_length = this.items.length;
      },
      async error => { }
    );

    sub.add(() => { this.getServices(); });
  }

  async getServices() {
    this.api.get('services/', this.token).subscribe(
      async data => {
        let objects: any = {}
        objects = data;

        this.services = objects;
      },
      async error => { }
    );
  }

  async OnSubmit() {
    let body = {
      'name': this.item.name,
      'service_id': this.item.service,
      'full_price': this.item.full_price,
      'session_price': this.item.session_price,
      'no_sessions': this.item.no_sessions
    }

    this.api.post("packages/", body, this.token).subscribe(
      async data => {
        this.getPackages();
        Swal.fire({
          title: 'Success!',
          text: 'Added Successfuly!',
          icon: 'success',
          confirmButtonText: 'Cool'
        })
      },
      async error => {
        Swal.fire({
          title: 'Error!',
          text: 'Something went wrong!',
          icon: 'error',
          confirmButtonText: 'Ok'
        });
      }
    );

    this.modalService.dismissAll();
  }

  async OnUpdate(key: any) {
    let body = {
      'name': this.new_item.name,
      'service_id': this.new_item.service,
      'full_price': this.new_item.full_price,
      'session_price': this.new_item.session_price,
      'no_sessions': this.new_item.no_sessions
    }

    this.api.update("packages/" + key, body, this.token).subscribe(
      async data => {
        this.getPackages();
        Swal.fire({
          title: 'Success!',
          text: 'Updated Successfuly!',
          icon: 'success',
          confirmButtonText: 'Cool'
        })
      },
      async error => {
        Swal.fire({
          title: 'Error!',
          text: 'Something went wrong!',
          icon: 'error',
          confirmButtonText: 'Ok'
        });
      }
    );

    this.modalService.dismissAll();
  }

  async onDelete(key: any) {
    if (confirm("Delete this item?")) {
      this.api.delete('packages/' + key, this.token).subscribe(
        async data => {
          this.getPackages();
          Swal.fire({
            title: 'Success!',
            text: 'Deleted Successfuly!',
            icon: 'success',
            confirmButtonText: 'Cool'
          })
        },
        async error => {
          Swal.fire({
            title: 'Error!',
            text: 'Something went wrong!',
            icon: 'error',
            confirmButtonText: 'Ok'
          });
        }
      );
    }
  }

  getService(id: any) {
    return this.services.find(i => i.id === id);
  }
}
